module.exports = __webpack_public_path__ + "pc/img/swiper_bg_04.148d3f7b.jpg";